import React, { useEffect } from 'react';
import './ListingSettings.scss';
import PLPFilters from '../../../own-days/Desktop/PLPFilters/PLPFilters';
import ActiveFilters from '../../components/Filters/ActiveFilters';
import { readQueryParam } from '../../../utils/helper';
import { useSelector } from 'react-redux';
import { odPushTTQEvent } from '../../../utils/tiktokPixel';
import { filterHelper } from '../../../own-days/Desktop/PLPFilters/PLPFilters.helper';
import { appendLenskartInPriceName } from '../../../own-days/helper';
// OD_NOT_REQ: _____Not Required for OWNDAYS
// import SearchBar from '../../components/SearchBar/SearchBar';

const FilterDtm = {
  updateFilterDtm: (filterName, filterType) => {
    let parentKeyToUpdateDtm = filterName;
    if (parentKeyToUpdateDtm?.indexOf('_id') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace(/_/g, '').replace('id', '');
    } else if (parentKeyToUpdateDtm?.indexOf('lenskart') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace('lenskart_', '');
    } else if (parentKeyToUpdateDtm?.indexOf('price') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.concat('range');
    }
    if (filterType) window.dtm.filterType = 'clear all';

    window.dtm[parentKeyToUpdateDtm] = 'clear';
  },
  updateCategoryDtm: (categoryData, dtmArg) => {
    let subC = '';
    const { userInfo, login, sort, filter } = dtmArg;
    const bCrumbArr =
      categoryData.breadcrumb && categoryData.breadcrumb.length ? categoryData.breadcrumb : [];
    const categoryType = categoryData.categoryType ? categoryData.categoryType.toLowerCase() : '';
    bCrumbArr.forEach(data => {
      if (data) {
        subC += `${data.label}-`;
      }
    });
    if (window.dtm !== undefined) {
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.allPage('listing page');
        window.dtm.LenskartRewamp.Listing.load.listing(
          categoryType,
          subC ? subC.slice(0, -1) : categoryType,
          filter,
          sort.toLowerCase(),
          login,
          login ? userInfo.result.id : '',
          dtmArg.obj
        );
      }
    }
  },
};

const ListingSettings = props => {
  const {
    dataLocale,
    categoryData,
    categoryID,
    redisCommonData,
    isCachedData,
    powerUrls,
    location,
    children,
    addingGaDataInFilterArray,
    filterArray,
    FilterDataObj,
    categoryActions,
  } = props;

  const plpBanner = useSelector(state => state?.plpBanner?.plpBannerData);
  const userInfo = useSelector(state => state.common.userInfo);
  const filterData = useSelector(state => state.category.filterData);

  const {
    /* PLP_SEARCH_PLACEHOLDER */ SEARCH_RESULTS,
    PLP_SUBTITLE,
    PRODUCTS,
    FOUND,
    FOR,
    SHOWING,
  } = dataLocale;

  const totalProducts =
    (categoryData && categoryData.result && categoryData.result.num_of_products) || 0;

  const pageParam = Number(readQueryParam('page', location.search, true));

  const searchTextParam = readQueryParam('q', location.search, true);

  const numberOfProductsNotShownDueToPageParam =
    !isCachedData && pageParam ? pageParam * redisCommonData.CATEGORY_PAGE_SIZE_COUNT : 0;

  useEffect(() => {
    if (searchTextParam) {
      odPushTTQEvent('Search', { userInfo });
    }
  }, []);

  const loadCatData = data => {
    let mystring = '';
    const incLimit = Object.keys(data).length - 1;
    Object.keys(data).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key;
      data[key].forEach((val, index) => {
        if (index === data[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (parentIndex === incLimit) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    let loc = '';
    if (location.hash.includes('dir')) {
      if (location.hash.split('dir')[0].length > 0 && location.hash.split('dir')[0].length !== 1) {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir') - 1,
          location.hash.lastIndexOf('true') + 4
        );
      } else {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir'),
          location.hash.lastIndexOf('true') + 4
        );
      }
    }

    let searchQuery = '';
    if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
      const queryParam = readQueryParam('q', location.search, true);
      searchQuery = `?q=${queryParam}`;
    }

    history.replaceState(
      `${location.pathname}${window.location.hash}`,
      null,
      location.pathname + `${searchQuery}${window.location.hash}`
    );

    categoryActions.loadCatAndFilterData(categoryID, mystring + loc, 0);
  };

  const handleFilter = (name, array, TempData, apiTempData = {}) => {
    filterHelper(name, FilterDataObj, TempData, apiTempData, array, categoryActions, loadCatData);
  };

  const modifySelectedFilterList = (childname, childid, currentFilterData) => {
    // debugger;
    console.log('selected filter list ===>', childname, childid, currentFilterData);
    const childData = FilterDataObj[currentFilterData.id] || [];
    const index = childData.findIndex(
      item => JSON.stringify(item) === JSON.stringify({ childid, childname })
    );

    if (index > -1) {
      childData.splice(index, 1);
    } else {
      childData.push({ childid, childname });
    }

    const filter = {
      [currentFilterData?.id]: childname,
    };
    const allFilter = [filter];

    let isContainFilterData = false;

    if (filterArray.length > 0) {
      isContainFilterData = filterArray.some(
        item => item[appendLenskartInPriceName(currentFilterData?.id)] === childname
      );
    }

    if (allFilter.length > 0 && !isContainFilterData) {
      const totalFilter = allFilter.length;
      const appliedFilterString = Object.assign({}, ...allFilter);

      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.filter.appliedFilter(appliedFilterString, totalFilter);
    }

    addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname);

    // Update DTM value when filter removed
    if (childData.length === 0) FilterDtm.updateFilterDtm(currentFilterData.id);

    handleFilter(currentFilterData.id, childData);
  };

  return (
    <div className="listing-settings">
      {(!plpBanner || (plpBanner && !plpBanner?.showBanner)) && (
        <>
          {!(categoryData?.result?.category_name === 'New Arrivals') && (
            <h1 className="listing-settings__title od-font-bold">
              {searchTextParam || `${categoryData?.result?.category_name || ''}`}
            </h1>
          )}
          {!(categoryData?.result?.category_name === 'New Arrivals') && (
            <div className="listing-settings__subtitle od-font-reg">
              {searchTextParam ? (
                <>
                  <span>{`${totalProducts} ${SEARCH_RESULTS} ${FOR} `}</span>
                  <span className="od-font-bold">{searchTextParam}</span>
                  <span>{` ${FOUND}`}</span>
                </>
              ) : (
                PLP_SUBTITLE
              )}
            </div>
          )}
        </>
      )}

      <div className="listing-settings__settings">
        <div className="listing-settings__settings__filter-wrapper">
          {filterData && (
            <PLPFilters
              addingGaDataInFilterArray={addingGaDataInFilterArray}
              categoryId={categoryID}
              filterArray={filterArray}
            />
          )}
          <div className="listing-settings__settings__active-filters">
            {categoryData && categoryData.result && (
              <span className="listing-settings__settings__active-filters__title od-font-bold">
                {SHOWING.toLowerCase()} {categoryData.result.num_of_products}{' '}
                {PRODUCTS?.toLowerCase()}
              </span>
            )}
            {categoryData.result && (
              <ActiveFilters
                {...props}
                categoryId={categoryID}
                initialIndex={numberOfProductsNotShownDueToPageParam}
                modifySelectedFilterList={modifySelectedFilterList}
                powerUrls={{ powerUrls }}
              />
            )}
          </div>
        </div>

        {/* OD_NOT_REQ: _____Not Required for OWNDAYS
        <SearchBar
          {...props}
          classes="listing-settings__search-bar"
          placeholder={PLP_SEARCH_PLACEHOLDER}
          variant="static"
        /> */}

        {/* <div>{children.inStockFilter}</div> */}

        <div>{children.sortFilter}</div>
      </div>
    </div>
  );
};

export default ListingSettings;
